import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContact } from '../contact_interfaces';
import { ContactsByRelationQuery } from '../queries/contacts_relationship_query';

export class ContactListService {
  private _activeRelationship: string = '';
  private _activeContacts: IContact[] = [];
  private _isContactLoading: boolean = false;

  constructor(
    private ngContactsByRelationQuery: ContactsByRelationQuery,
    private loadContactsCommand: ICommand,
    private accountModel: any
  ) {}

  get activeRelationship(): string {
    return this._activeRelationship;
  }

  get activeContacts(): IContact[] {
    return this._activeContacts;
  }

  get isContactLoading(): boolean {
    return this._isContactLoading;
  }

  loadContacts(relationship: string): void {
    this._isContactLoading = true;
    this.loadContactsCommand(this.accountModel.student_nk)
      .then(() => {
        const activeRelation = !_4.isEmpty(relationship)
          ? relationship
          : _4.first(this.ngContactsByRelationQuery.result.relationships);
        this.activateRelationship(activeRelation);
        this._isContactLoading = false;
      })
      .catch(() => {
        this._isContactLoading = false;
      });
  }

  activateRelationship(relationship: string) {
    this._activeRelationship = relationship;
    this._activeContacts = _4.get(this.ngContactsByRelationQuery.result.contacts, relationship, []);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/services/contact_list_service.ts